<ng-container *ngIf="formGroup">
  <div [formGroup]="formGroup">
    <div class="d-flex gap-4 flex-column">
      <div *ngFor="let bucket of accountBuckets$ | async" class="d-flex gap-3 flex-column account-type-card">
        <div class="d-flex align-items-center gap-2">
          <app-radio-button-input
            formControlName="accountType"
            [controlId]="'accountType-' + bucket.accountTypeId"
            [value]="bucket.accountTypeId"
            [name]="'accountType'" />
          <app-form-option-label [labelFor]="'accountType-' + bucket.accountTypeId" i18n>
            {{ bucket.accountType?.name }}
          </app-form-option-label>
        </div>

        <div class="d-flex flex-column">
          <div *ngFor="let account of bucket.accounts; let last = last">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column gap-2">
                <div class="account-employer">{{ account.employer }}</div>
                <div class="account-id">{{ account.id | leadingZero : 8 }}</div>
              </div>
              <div class="account-balance">{{ account.totalBalance | currency }}</div>
            </div>
            <hr class="divider" *ngIf="!last" />
          </div>
        </div>
      </div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.accountType.invalid"
        [errors]="formGroup.controls.accountType.errors"
        [customErrorMessages]="customErrorMessages" />
    </div>
  </div>
</ng-container>
